import React, { useCallback } from 'react'
import { useHistory } from 'react-router-dom'

import EventForm from './EventForm'
import API from '../../../../services/api'
import Container from '../../../atoms/page/Page'
import NewEventForm from '../event'

function CreateEvent() {

  const onSave = useCallback((data: API.EventRequest) => {
    return API.createEvent(data)
  }, [])

  const history = useHistory()

  const onCancel = useCallback(() => {
    history.push('/events')
  }, [history])

  if (process.env.REACT_APP_USE_NEW_EVENT_UI === 'true') {
    return <NewEventForm mode="create" />
  }

  return (
    <Container>
      <EventForm onSave={onSave} onCancel={onCancel} />
    </Container>
  )
}

export default CreateEvent
